function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "f67634cf-02d9-42c2-81fe-a2403926694d",
  x1: 151.23,
  y1: 806.75,
  x2: 151.23,
  y2: 333,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bcdb2a22-93f8-4c81-b6d3-8137c026104f",
  x1: 198.16,
  y1: 493.79,
  x2: 225.47,
  y2: 493.79,
  xlinkHref: "#f67634cf-02d9-42c2-81fe-a2403926694d"
}));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "dark analytics");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1162,320.69a270,270,0,0,0-44.82-70.22l-621.86-6,512-70.7a294.88,294.88,0,0,0-103.88-20.26C854.12,114.34,790.78,90.8,721.68,90.8c-62,0-119.33,19-166.07,51.1A294,294,0,0,0,422.5,110.36c-138.17,0-253.3,94.1-279.13,218.88Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#6f6fff",
  opacity: 0.1
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M752.68,429.38l67.84,10.35h0l2.26.34h0l1.54.25,2.83.42,11.27,1.72,120.88,18.43,39.53,6,175.9,26.84c-23.35,86.08-89.73,155.6-175.9,186.35q-5.54,2-11.17,3.75c-26.75,53.88-71.49,98-126.8,125.34H600A285.65,285.65,0,0,1,546.6,775q-5-4-9.7-8.21-1.85-1.64-3.64-3.29-2.38,2.16-4.82,4.26-5.7,4.92-11.68,9.55a287,287,0,0,1-51.65,31.86H210.31a287.89,287.89,0,0,1-35.65-20.35C106.31,743.11,60,669.39,53.85,585.09l120.71-12.61,33.94-3.55L311,558.22l84.22-8.8L276.41,532,203.5,521.33l-28.94-4.25L61.46,500.51a263.25,263.25,0,0,1,25.25-62.69l87.85-9.08,72.5-7.48,72.75-7.5L444,401l1.7-.19,370.69-38.25L833,360.78l165.83-17.12,165.62-17.09a260.62,260.62,0,0,1,19.38,98.77c0,1.36,0,2.69,0,4Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#6f6fff",
  opacity: 0.1
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1158,670.22S1144,664.5,1099.21,685s-50.34,17.92-61.92,14.78-18-3.88-30.46-21c0,0-8.76-47.48-17.23-54.83s-44.5,4.19-44.5,4.19-43.19,9.9-51.42-47.82c0,0,5.84-43.5-2.11-56.85,0,0,16,6.92,42.54-4.26s47.69,12,47.69,12,6.68,17.29,6,27.6,3.53,14.19,16.16,9.21c0,0,6.21-8.84-2.58-23.43s-15.06-25.46-12.61-36.79,9.51-27.05,32.17-34.91,53.44-9.37,68.22-15.52,18.35-10.16,18.35-10.16-9.09,9.11,12.33,47.73,7.76,55.38,7.76,55.38-11.39,27.15-61.69,25c0,0-48.47,1.77-22.05,22.32,0,0,16.92-3.44,42.23-11.49s43.56,25.15,48.1,48.26S1158,670.22,1158,670.22Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#6f6fff"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1092.86,476.56l.26-.07c2,7.37-19.72,37-38.24,60.52l-.21-.17C1080.79,503.63,1094.36,482.22,1092.86,476.56Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#444053"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1055.05,536.36l.11.3c-14.79,18.8-33.39,41.25-48.28,57.87-1.42,1.58-2.83,3.25-4.19,4.94l-.42-.34c1.36-1.7,2.77-3.37,4.2-5C1021.35,577.55,1040.27,555.15,1055.05,536.36Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#444053"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M1002.63,598.68l.29.51C975.82,633,974,685.55,974,686l-5.72-6.6C968.31,678.94,975.34,632.75,1002.63,598.68Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#444053"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M1126.59,651.87s-31.95-16.61-56.85-10.65-81-21.07-81-21.07-23.81-9.67-28.59-20.69c0,0-16.33-17.27-17.26-26.21S926.09,541.86,915.72,541",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M1122,667.86s-16.09-10.84-14.23-23.48",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M1097.28,681.86s-23-8.35-25.32-41.11",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M1060.14,690.34s-22-18.24-14.69-50.12",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M1015.52,681.43s-14.65-30.71-1.61-50.69",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M1127,631.62s-16.64,5.28-13.07,14",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M1106.89,601.41s-22.27,7.07-22.8,38.57",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M1075.82,594.14s-20.26,25-18.78,47.76",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M1040.33,604s-20.13,19.24-17.56,29.94",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M1028.19,597.16s-18.88,3.38-21.52-2.81",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M1003.66,574.37s9.54,12.63,12,9.8",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M1098.21,566.38s-47.58,3.45-58.35-10.89",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M993.65,510.72s22.33,47.93,38.54,54",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M1017.07,487.89s13.71,44.08,30.71,57.84",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M1118.24,530s-36.19,15.54-57.92-.18",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M1049.31,478.49s8.27,32.41,19.41,40.23",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M1112.77,493.69s-20.34,7.7-27.93,1.8",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10,
  strokeWidth: 0.75
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M986.24,585s0,28.25-7.69,30.25",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M923.37,621.56s30.54,2.61,44.63-13.15",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M978.36,551.58S971,580.24,950.58,588",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M905,591.38s21.63,7.51,40.22-11.63",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M954.32,527s-2,24.34-15.27,35.72",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M905.87,554.3s17.94.12,22.14-5.73",
  transform: "translate(-16.15 -90.8)",
  fill: "none",
  stroke: "#444053",
  strokeMiterlimit: 10
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M998.85,304V786.79a22.4,22.4,0,0,1-22.39,22.41H197a22.39,22.39,0,0,1-22.29-20.35,20,20,0,0,1-.1-2.06V304c0-.49,0-1,.05-1.44H998.78C998.81,303,998.85,303.49,998.85,304Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#4c4c78"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M976.46,282.59H197a22.39,22.39,0,0,0-19.4,11.2,22.14,22.14,0,0,0-2.94,9.76H998.78A22.39,22.39,0,0,0,976.46,282.59Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#6f6fff"
});

var _ref35 = /*#__PURE__*/React.createElement("circle", {
  cx: 180.8,
  cy: 202.99,
  r: 5.6,
  fill: "#ededf4"
});

var _ref36 = /*#__PURE__*/React.createElement("circle", {
  cx: 197.59,
  cy: 202.99,
  r: 5.6,
  fill: "#ededf4"
});

var _ref37 = /*#__PURE__*/React.createElement("circle", {
  cx: 214.39,
  cy: 202.99,
  r: 5.6,
  fill: "#ededf4"
});

var _ref38 = /*#__PURE__*/React.createElement("rect", {
  x: 187.35,
  y: 230.6,
  width: 116.3,
  height: 10.71,
  fill: "#6f6fff"
});

var _ref39 = /*#__PURE__*/React.createElement("rect", {
  x: 187.35,
  y: 282.83,
  width: 116.3,
  height: 10.71,
  fill: "#6f6fff",
  opacity: 0.5
});

var _ref40 = /*#__PURE__*/React.createElement("rect", {
  x: 187.35,
  y: 319.74,
  width: 116.3,
  height: 10.71,
  fill: "#6f6fff",
  opacity: 0.5
});

var _ref41 = /*#__PURE__*/React.createElement("rect", {
  x: 187.35,
  y: 356.66,
  width: 116.3,
  height: 10.71,
  fill: "#6f6fff",
  opacity: 0.5
});

var _ref42 = /*#__PURE__*/React.createElement("rect", {
  x: 187.35,
  y: 393.58,
  width: 116.3,
  height: 10.71,
  fill: "#6f6fff",
  opacity: 0.5
});

var _ref43 = /*#__PURE__*/React.createElement("rect", {
  x: 187.35,
  y: 430.5,
  width: 116.3,
  height: 10.71,
  fill: "#6f6fff",
  opacity: 0.5
});

var _ref44 = /*#__PURE__*/React.createElement("rect", {
  x: 187.35,
  y: 467.42,
  width: 116.3,
  height: 10.71,
  fill: "#6f6fff",
  opacity: 0.5
});

var _ref45 = /*#__PURE__*/React.createElement("rect", {
  x: 187.35,
  y: 504.34,
  width: 116.3,
  height: 10.71,
  fill: "#6f6fff",
  opacity: 0.5
});

var _ref46 = /*#__PURE__*/React.createElement("rect", {
  x: 427.82,
  y: 269.98,
  width: 515.34,
  height: 1.72,
  fill: "#dce0ed",
  opacity: 0.5
});

var _ref47 = /*#__PURE__*/React.createElement("rect", {
  x: 427.82,
  y: 309.96,
  width: 515.34,
  height: 1.72,
  fill: "#dce0ed",
  opacity: 0.5
});

var _ref48 = /*#__PURE__*/React.createElement("rect", {
  x: 427.82,
  y: 349.94,
  width: 515.34,
  height: 1.72,
  fill: "#dce0ed",
  opacity: 0.5
});

var _ref49 = /*#__PURE__*/React.createElement("rect", {
  x: 427.82,
  y: 389.92,
  width: 515.34,
  height: 1.72,
  fill: "#dce0ed",
  opacity: 0.5
});

var _ref50 = /*#__PURE__*/React.createElement("rect", {
  x: 427.82,
  y: 429.9,
  width: 515.34,
  height: 1.72,
  fill: "#dce0ed",
  opacity: 0.5
});

var _ref51 = /*#__PURE__*/React.createElement("polygon", {
  points: "943.16 431.6 427.18 431.6 427.18 352.98 474.51 376.3 523.48 382.94 566.45 369.99 618.29 329.78 644.37 314.72 663.43 311.05 681.67 312.03 711.67 326.84 752.44 352.81 784.43 356.93 809.81 348.18 863.58 304.13 891.04 294.35 919.77 298.79 943.16 312.3 943.16 431.6",
  fill: "#6f6fff",
  opacity: 0.5
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M533.27,473.77c-46.47,0-89.4-28.42-89.94-28.78l1.28-1.91c.66.44,66.76,44.17,122.91,22.26,20.47-8,35.06-20.4,49.16-32.42,14.72-12.54,28.63-24.39,47.58-29.53,21.75-5.89,45.51-.56,63.56,14.28,15.43,12.68,46.17,33,78.63,27,16.56-3.11,30.51-15.2,45.28-28C880,392.09,909.32,366.72,960,403.12L958.64,405c-49.18-35.35-77.77-10.58-105.41,13.38-15,13-29.19,25.29-46.35,28.51-33.4,6.27-64.78-14.5-80.52-27.44-17.48-14.36-40.47-19.53-61.49-13.83-18.46,5-32.18,16.69-46.7,29.06-14.25,12.14-29,24.69-49.81,32.81A96,96,0,0,1,533.27,473.77Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#6f6fff"
});

var _ref53 = /*#__PURE__*/React.createElement("circle", {
  cx: 675.79,
  cy: 310.82,
  r: 12.77,
  fill: "#6f6fff"
});

var _ref54 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("rect", {
  x: 473.36,
  y: 521.17,
  width: 75.75,
  height: 16.07,
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("rect", {
  x: 647.3,
  y: 521.17,
  width: 75.75,
  height: 16.07,
  fill: "#dce0ed"
}), /*#__PURE__*/React.createElement("rect", {
  x: 821.23,
  y: 521.17,
  width: 75.75,
  height: 16.07,
  fill: "#dce0ed"
}));

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M484.15,724.19c0-23.46,19.09-41.48,42.55-41.48H527V672h-.34c-29.35,0-53.22,22.81-53.22,52.16a53.13,53.13,0,0,0,18.23,40.06l7.56-7.57A42.45,42.45,0,0,1,484.15,724.19Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#6f6fff"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M528.1,672v10.68a42.55,42.55,0,1,1-27.76,75l-7.56,7.56A53.2,53.2,0,1,0,528.1,672Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#6f6fff",
  opacity: 0.5
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M877,682.18c23.46,0,41.48,19.08,41.48,42.54v.34h10.67c0-.11,0-.22,0-.34,0-29.34-22.81-53.22-52.16-53.22a53.09,53.09,0,0,0-40,18.23l7.56,7.57A42.45,42.45,0,0,1,877,682.18Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#6f6fff",
  opacity: 0.5
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M929.16,726.13H918.49a42.55,42.55,0,1,1-75-27.77l-7.56-7.56a53.21,53.21,0,1,0,93.27,35.33Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#6f6fff"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M722.35,675.17l-2.12,10.62c15.62,6.31,25.6,21.62,25.6,39.47a42.55,42.55,0,1,1-59.6-39l-4.78-9.55a53.22,53.22,0,1,0,75.06,48.52C756.51,702.23,742.87,682.57,722.35,675.17Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#6f6fff",
  opacity: 0.5
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M704.62,682.09a37,37,0,0,1,14.81,3.08l2.12-10.62a47,47,0,0,0-16.93-3.14,52.88,52.88,0,0,0-21.83,4.7l4.77,9.56A42.24,42.24,0,0,1,704.62,682.09Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#6f6fff"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M249.83,474.44c2.86-7.68-2.24-15.77-2.24-15.77l-.41-17.59c2.25-4.64-5.5-16.16-5.5-16.16s-1.84-8.7-3.47-9.51-3.46-4.44-3.46-4.44a2.72,2.72,0,0,0-1.56-2.39,115.46,115.46,0,0,1-7.44-16.33c-1.14-3.12-2.15-6.46-1.5-9.71a16.14,16.14,0,0,1,.73-2.43l.19-.49.08-.21.06-.17a12.4,12.4,0,0,0,1.21-5.19c-.23-3.75-3.68-6.49-7.11-8.08s-7.28-2.63-10-5.27c-3.38-3.32-4.17-8.35-4.95-13s-2-9.7-5.82-12.5c-3.38-2.47-8-2.52-12.13-1.82a40.41,40.41,0,0,0-15.64,6.23c-4.55,3.05-8.61,7.1-13.87,8.69-1.93.59-4,.81-5.88,1.45a14.52,14.52,0,0,0-8.75,8.75h0c-.07.18-.13.37-.19.56s-.16.48-.23.72l-.15.61c-.05.23-.11.47-.15.71s-.07.4-.1.61-.06.48-.08.73,0,.4-.05.6,0,.5,0,.76a31.81,31.81,0,0,0-5.6,7c-6.73,10.65-15.09,26.06-18.81,33l-.18.33c0-.12,0-.21,0-.21s-16.41,16.48-6.83,14.25c.72-.16,1.37-.28,2-.36l-.1,1.83,0,.05c-1.53,1.92-8.15,8.56,4.18,13.47,10.22,4.08,31.14,5.13,38,5.36l-.6,2.9c-10.6,8.69-6.52,18.6-6.73,25.06s-1.22,14.16-1.22,14.16S141,488,141.58,491.82s-3.26,10.11-3.26,10.11-5.7,6.27-5.09,10.31-1,9.3-1,9.3-3.87,7.08-2.25,11.11.82,6.28.82,6.28-8.36,1.21-9,5.65-8.15,6.07-8.15,6.07-13.45,4.85-16.72,7.07-20.58,18.4-20.58,18.4S59,594,58.06,595.83s-11.16,9.55-6.42,16.83c.23.36.47.72.72,1.09a62,62,0,0,0,18.82,17.82c3.28,2,6.55,4.29,7.52,5.8,2.14,3.33,37.91,26.23,37.91,26.23s15.73,13.81,25.85,23.44l.77,4.63c-.13.21-.27.42-.39.65a2.81,2.81,0,0,0,.95,2.74l.14.83s4.08,34.36,7.75,50.43c2.42,10.64.7,18.66-.74,22.87-3.81-4.21-4.26-5.73-4.26-5.73a43.55,43.55,0,0,0-2.59,8.47c-.06.42-.1.82-.12,1.21a.31.31,0,0,0-.28.12l-1.42,2c-1.56,2.16-2.93,4.44-4.33,6.71-3.2,5.2-13.27,7.64-13.27,7.64a9.88,9.88,0,0,1-2.7.94,30.79,30.79,0,0,1-8.57.27,13.27,13.27,0,0,0-2.52.62,9,9,0,0,0-1.92.88v.05c-4.39,2.84-2.79,8.08-2.79,8.08l0,0,0,0,.11.08.11.06.18.12.27.16.22.14.25.14.24.14.31.18.26.14.67.36.3.16.44.22.35.17.47.24.46.21.81.36.47.21.53.22.53.22.54.21,1,.37.5.17.71.23.53.17.82.24.45.13,1.27.32.41.09,1,.21.26,0,.21,0,1.09.17.31.05c.48.07,1,.13,1.45.17l.32,0,1.16.08h.48c.36,0,.73,0,1.1,0h.44l1.5-.06.31,0,1.23-.13.54-.07,1.08-.19.51-.09c.52-.11,1-.23,1.56-.38a97.63,97.63,0,0,1,35-3c9,.76,11.25-2.32,11.25-2.32a4.16,4.16,0,0,0,.46-.76c.05-.1.09-.21.13-.31a5.54,5.54,0,0,0,.21-.57c0-.13.07-.26.11-.39s.09-.38.13-.58,0-.28.07-.43,0-.15,0-.23,0-.4.05-.6a22.27,22.27,0,0,0-.36-5.18,59.47,59.47,0,0,0-3.28-11l-.64.45c-.07-.34-.14-.69-.21-1.06-2.21-11.84-3-40.27-3.05-43.29h0a5.39,5.39,0,0,0,3.42-1.18,2.85,2.85,0,0,0,.26-.22c7.64-6.21,3.89-34.57,1.37-38.51s-3-24.18-3.9-30.63c-.43-3.06-2.05-4-4.13-4l-.89,0c-.3-6,.57-20.11,1.26-29.74v0c0-.63.09-1.23.13-1.82l1.92.11,2.86-17s1.63-6.27,11.62-24.06,11-37.19,11-37.19,3.06-5.87,2.24-8.49c-.21-.69-.55-2.6-.93-5.1a65.49,65.49,0,0,1,10.66-5.21c10.69-4.32,18.7-12.41,22.43-16.43l.59-.63a44.25,44.25,0,0,1,2.52,4.32s8.76-6.06,13.25-11.32a7.19,7.19,0,0,0,1.13-2c2.7-6.73-.06-21.09-.06-21.09C254.22,480.1,249.83,474.44,249.83,474.44Z",
  transform: "translate(-16.15 -90.8)",
  fill: "url(#f67634cf-02d9-42c2-81fe-a2403926694d)"
});

var _ref62 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M205.72,515.34c-.41.74-3.35,2.5-6.93,4.44-.33-2.6-.57-4.58-.62-5.18-.22-2.24,4.55-12.22,4.55-12.22s9.11-12.23,8.9-14.06,3.52-7.13,3.52-7.13l8.25-13.4a6.06,6.06,0,0,0,.86,6.27c2.49,3.26.41,9.78.41,9.78l.5,8.22.05.81c-.3.29-1.62,1.56-4.56,4.21-2.72,2.45-2.23,3.19-1.93,3.39-.61,1.1.15,1.29.15,1.29.24,0,.48,0,.71-.05l-.65.6C213.82,507.06,206.46,514,205.72,515.34Z",
  transform: "translate(-16.15 -90.8)",
  fill: "url(#bcdb2a22-93f8-4c81-b6d3-8137c026104f)"
}));

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M151.12,363.78c-2.48,2.57.34,6.2-1.58,9-1.09,1.57-3.49,2.55-4.85,4-2.65,2.88-.65,6.56.63,9.83,4.67,11.95-2.34,25.56-17,33a30.81,30.81,0,0,0,20.16,1.64c6.56-1.75,11.6-5.83,12.93-10.47.94-3.29.14-6.79,1.83-9.95,2.63-4.9,10.68-7.86,13.06-12.82,1.86-3.88-.18-8.09-2.54-11.84A94.15,94.15,0,0,0,163.58,363c-2.29-2.52-2.3-3.51-6-2.83A17.74,17.74,0,0,0,151.12,363.78Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#985c7e"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M173,398.85a38.27,38.27,0,0,1-2.35,10.35c-1.4,4.25-2.84,8.54-5.25,12.3s-5.95,7-10.27,8.15a12.82,12.82,0,0,0,10.7,3.1c2.74-.49,5.53-1.88,8.19-1a25.5,25.5,0,0,1,3.53,1.88c3.91,2,9,.53,11.84-2.85a13.39,13.39,0,0,0,2.06-12.43c-.8-2.54-2.22-4.85-3-7.4-1.09-3.78-.66-8-2.49-11.48-2.66-5.05-10.06-8-15.06-10C170.66,392.14,173.13,395.61,173,398.85Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#985c7e"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M166.08,389.47a38.27,38.27,0,0,1-2.35,10.35c-1.4,4.25-2.84,8.54-5.25,12.3s-5.95,7-10.27,8.15a12.84,12.84,0,0,0,10.7,3.1c2.75-.49,5.53-1.88,8.19-1a24.94,24.94,0,0,1,3.53,1.88c3.92,2,9,.53,11.84-2.84a13.45,13.45,0,0,0,2.07-12.44c-.8-2.54-2.23-4.85-3-7.4-1.09-3.78-.66-8-2.49-11.48-2.66-5-10.05-8-15.06-10C163.74,382.77,166.2,386.23,166.08,389.47Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M171,622.73s-3,36.68-1.7,41.59,3.51,71.25,3.51,71.25.9,38.69,3.91,46.8-20.35,5.82-21.15,5.72S149,771.55,149,771.55s5.71-10,2.1-26-7.62-50-7.62-50l-6.61-40.09s.9-9.42-2.61-14.73-8-40.09-7-43.1,24.82-9.62,24.82-9.62l10.26,13.43Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#ecb4b6"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M127.58,605.35v.08l.06.62c.06.67.14,1.37.22,2.09,1.25,11.6,4.11,29,6.51,32.63s2.73,9.18,2.7,12.33c0,.36,0,.68,0,1,0,.89-.08,1.43-.08,1.43l5.09,30.83.21,1.3,1.31,8s4,34.07,7.62,50a42.13,42.13,0,0,1-.45,21.82q-.15.5-.3.93a20.26,20.26,0,0,1-1.35,3.2s.82,2.32,1.89,5.23c.24.65.49,1.32.74,2l.4,1.06c1.55,4.1,3.19,8.19,3.58,8.23.8.11,24.16,2.41,21.15-5.71a24.13,24.13,0,0,1-.9-3.61c-2.29-12.41-3-43.19-3-43.19s-2.2-66.34-3.51-71.25c-.87-3.27.18-20.61,1-31.85v0c.4-5.62.74-9.71.74-9.71l-8.72-21.25-10.26-13.42s-17.1,4.75-22.93,8l-.17.1c-1,.55-1.58,1.06-1.72,1.5C127.09,598.45,127.21,601.37,127.58,605.35Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.07
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M143.07,651.69s11.33,3,10.33,6.31Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.05
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M149.1,771.55s1.23,3.47,2.63,7.24c1.6.75,2.82,1.23,2.82,1.23s4.36-4.06-1.4-10c-.93-1-1.72-1.82-2.4-2.58A22.5,22.5,0,0,1,149.1,771.55Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M143.57,773.5c.44,2.4,5.7,5.06,8.56,6.35,1.08.48,1.82.77,1.82.77a5.47,5.47,0,0,0,1.2-1.91c.67-1.75.79-4.6-2.61-8.11-.79-.82-1.48-1.57-2.09-2.25-3.82-4.24-4.27-5.77-4.27-5.77a43.3,43.3,0,0,0-2.55,8.4A8.35,8.35,0,0,0,143.57,773.5Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#cc8294"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M143.57,773.5c.44,2.4,5.7,5.06,8.56,6.35,1.55,4.1,3.19,8.19,3.58,8.23.8.11,24.16,2.41,21.15-5.71a24.13,24.13,0,0,1-.9-3.61c-1.35.94-4.1,2.87-6.48,4.57-3.3,2.35-8.26.6-8.26.6l-6.07-5.22-1.51-1.3a8.72,8.72,0,0,1-2.65-.63,13,13,0,0,1-5.21-4.18c-1.15-1.23-1.8-1.56-2.15-1.62A8.35,8.35,0,0,0,143.57,773.5Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M106.35,799.21a41.48,41.48,0,0,0,14.33,5.73,28.79,28.79,0,0,0,13.07-.37,95.25,95.25,0,0,1,34.38-3c8.81.76,11.07-2.3,11.07-2.3,1.47-2,1.42-5.48.82-9a59,59,0,0,0-3.23-10.93s-4,2.81-7.31,5.17-8.26.6-8.26.6l-7.58-6.52c-4.81-.35-7.86-4.81-7.86-4.81-2.12-2.26-2.54-1.5-2.54-1.5l-1.4,1.94c-1.54,2.13-2.88,4.4-4.25,6.65-3.15,5.16-13,7.57-13,7.57a9.72,9.72,0,0,1-2.66.94,30,30,0,0,1-8.42.26,11.19,11.19,0,0,0-4.22,1.44C104.72,793.89,106.35,799.21,106.35,799.21Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#cc8294"
});

var _ref73 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.9,
  cy: 692.07,
  r: 0.78,
  fill: "#4b4b5b"
});

var _ref74 = /*#__PURE__*/React.createElement("circle", {
  cx: 126.3,
  cy: 696.16,
  r: 0.78,
  fill: "#4b4b5b"
});

var _ref75 = /*#__PURE__*/React.createElement("circle", {
  cx: 130.09,
  cy: 701.98,
  r: 0.78,
  fill: "#4b4b5b"
});

var _ref76 = /*#__PURE__*/React.createElement("circle", {
  cx: 116.88,
  cy: 700.01,
  r: 0.78,
  fill: "#4b4b5b"
});

var _ref77 = /*#__PURE__*/React.createElement("circle", {
  cx: 131.66,
  cy: 694.6,
  r: 0.78,
  fill: "#4b4b5b"
});

var _ref78 = /*#__PURE__*/React.createElement("circle", {
  cx: 135.4,
  cy: 701.57,
  r: 0.78,
  fill: "#4b4b5b"
});

var _ref79 = /*#__PURE__*/React.createElement("circle", {
  cx: 121.66,
  cy: 698.44,
  r: 0.78,
  fill: "#4b4b5b"
});

var _ref80 = /*#__PURE__*/React.createElement("circle", {
  cx: 111.73,
  cy: 701.2,
  r: 0.78,
  fill: "#4b4b5b"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M106.35,799.21s13.42,9.22,27.4,5.36a95.25,95.25,0,0,1,34.38-3c8.81.76,11.07-2.3,11.07-2.3a6.72,6.72,0,0,0,1.12-3.25q0-.33.06-.69a22,22,0,0,0-.36-5c-1.83,1.36-5.64,3-13.35,3.28-13.33.43-30.91,3.83-30.91,3.83l-17-.69s-9.52-2.07-9.48-5.61C104.72,793.89,106.35,799.21,106.35,799.21Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M130.19,802.51a4.12,4.12,0,0,0,.85.06c3,0,10.24-1.58,14.56-2.59a21.24,21.24,0,0,1,3.72-.53c4-.2,13.79-.68,19.31-.64h.13a28.88,28.88,0,0,0,11.56-2.8q0-.33.06-.69a28.38,28.38,0,0,1-11.75,2.89c-5.52,0-15.36.44-19.34.64a21.56,21.56,0,0,0-3.83.55c-3.83.9-13,3-15.16,2.52Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#cc8294"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M137.05,654.07c0,.89-.08,1.43-.08,1.43l5.09,30.83,2.62,2.5a67.76,67.76,0,0,1,7.11,7.51c3,4.66,13.63,2.25,13.43,1.8s-4.56-22.4-4.56-22.4l-3.46-8.87s-3.59,2.26-7.13-1.5c-2.23-2.36-7.22-7-10.62-10.1l-2.38-2.17C137.07,653.46,137.06,653.78,137.05,654.07Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.03
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M127.58,605.43l.06.62c.06.67.14,1.37.22,2.09.74-.27,1.47-.57,2.18-.89.35-.15.69-.3,1-.46a52.65,52.65,0,0,0,9.31-5.76l-8.73-3.74-2.57-1.11c-1,.55-1.58,1.06-1.72,1.5C127.09,598.46,127.21,601.41,127.58,605.43Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.05
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M52.73,613.06c.23.36.47.72.71,1.08a61.27,61.27,0,0,0,18.5,17.67c3.23,2,6.44,4.25,7.4,5.75,2.1,3.31,37.28,26,37.28,26s16.36,14.5,26.26,24.06l1.26,1.23.61.59c.72.71,1.39,1.39,2,2,.87.89,1.61,1.68,2.17,2.33.21.24.4.46.56.66s.39.5.52.69c3,4.66,13.62,2.26,13.43,1.81s-4.56-22.4-4.56-22.4l-3.46-8.87a5.39,5.39,0,0,1-4.55.31,6.94,6.94,0,0,1-2.58-1.81c-2.23-2.37-7.23-7-10.62-10.1-2-1.83-3.45-3.13-3.45-3.13l-11.27-12.78s-14.43-18.79-25.25-23.45c0,0,12.18-5,20.89-6.31a38.57,38.57,0,0,0,9.67-2.35c.34-.15.69-.3,1-.46a52.79,52.79,0,0,0,9.3-5.76l-8.72-3.75L84,576.38c-.29,0-2.94.17-4.89.31l-2.08.14s-17.09,17.74-18,19.54S48.07,605.84,52.73,613.06Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#ecb4b6"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M103.24,604.79s-19.69,2.4-23.6,6.46c0,0,17.28,1.21,18,3.46,0,0-9.88-6.68-12.63-5Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.03
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M144.14,688.86l.61.59c.72.71,1.39,1.39,2,2,.87.89,1.61,1.68,2.17,2.33l2.55-3.31a10.38,10.38,0,0,0-2.9-1.75,5,5,0,0,0-4.42.13Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.05
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M145.39,696.22a13.78,13.78,0,0,0,2.06.86l2-2.64,2.59-3.36a10.28,10.28,0,0,0-2.9-1.76,5,5,0,0,0-4.41.13,6.25,6.25,0,0,0-2.35,2.6S141.62,694.3,145.39,696.22Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#cc8294"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M145,695.81l.41.41a13.78,13.78,0,0,0,2.06.86l2-2.64c.22.27.39.5.52.69,3,4.66,13.62,2.26,13.43,1.81s-4.56-22.4-4.56-22.4l-3.46-8.87a5.39,5.39,0,0,1-4.55.31c-.79.82-.93,1.85,0,3.15a21.08,21.08,0,0,1,3.42,10c1.35,3.72-2.75,8.28-5.11,10.2a6.31,6.31,0,0,1-1.28.85,3,3,0,0,0-1.14,1.28A24.21,24.21,0,0,0,145,695.81Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.05
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M146.18,695.81l4.56,4.59a34.11,34.11,0,0,1,13.8,17.21,35.82,35.82,0,0,0,1.63,4,18.12,18.12,0,0,1,1.19,5.62c.11,1.16.16,2.31.2,3.32a5.38,5.38,0,0,0,1.36,3.46l.06.07a5.39,5.39,0,0,0,7.36.62,2.85,2.85,0,0,0,.26-.22c7.51-6.16,3.83-34.27,1.35-38.18s-2.94-24-3.84-30.37c-.42-3-2-3.91-4.06-3.95s-4.78.81-7.12,1.07l-.39,0c-4.66.38-13.62,1.76-10.48,6.09a21.13,21.13,0,0,1,3.41,10c1.66,4.59-4.95,10.45-6.38,11S146.18,695.81,146.18,695.81Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#cc8294"
});

var _ref91 = /*#__PURE__*/React.createElement("circle", {
  cx: 136.62,
  cy: 602.17,
  r: 1.33,
  fill: "#4b4b5b"
});

var _ref92 = /*#__PURE__*/React.createElement("circle", {
  cx: 138.65,
  cy: 607.15,
  r: 1.33,
  fill: "#4b4b5b"
});

var _ref93 = /*#__PURE__*/React.createElement("circle", {
  cx: 144.89,
  cy: 615.17,
  r: 1.33,
  fill: "#4b4b5b"
});

var _ref94 = /*#__PURE__*/React.createElement("circle", {
  cx: 141.79,
  cy: 611.05,
  r: 1.33,
  fill: "#4b4b5b"
});

var _ref95 = /*#__PURE__*/React.createElement("circle", {
  cx: 147.47,
  cy: 619.92,
  r: 1.33,
  fill: "#4b4b5b"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M168.93,714.83s1.11,13,0,19.14a5.38,5.38,0,0,0,7.42.69,2.85,2.85,0,0,0,.26-.22c7.51-6.16,3.83-34.27,1.35-38.18s-2.94-24-3.84-30.37c-.42-3-2-3.91-4.06-3.95s-4.78.81-7.12,1.07c0,6.37.35,21,2,25.86C167.13,695.09,168.93,714.83,168.93,714.83Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M172.24,688.26c1.4,4.92,3.5,18.45,3.3,25.67-.14,5.29.47,15.62.8,20.73a2.85,2.85,0,0,0,.26-.22c7.51-6.16,3.83-34.27,1.35-38.18s-2.94-24-3.84-30.37c-.42-3-2-3.91-4.06-3.95C170.33,668.39,171.12,684.36,172.24,688.26Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M167.12,662.25c.28,5.12,1.12,18.8,2.5,22.71,1.71,4.9,3.54,28.35,3.62,29.34l-.6.05c0-.24-1.9-24.37-3.6-29.18-1.4-4-2.24-17.58-2.52-22.8Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#cc8294"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M162.72,409.67s-9.72,1.73-15.24,3.77-6.31,3.14-6.31,3.14l-5.71.91v-6.12s-20.46,1.52-22.52.68a.32.32,0,0,1-.13-.08c-1-1,.6,7.92-.9,9.82s-8,8.49,4.11,13.37,39.58,5.38,39.58,5.38l7.82-15.44Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#ff718d"
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  d: "M193.48,439.13l-21.64-4.61A52.28,52.28,0,0,0,178.1,418c.78-4.64.68-9.58-1.46-13.92-6.21-12.62,16.84-19.23,16.84-19.23s8.43,13,16,19.58c2.54,2.19,5,3.66,7,3.66C224.55,408.06,193.48,439.13,193.48,439.13Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#ecb4b6"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M77,578.63s9.42,22.25,18,22.65c5.19.24,21.19,2.45,33.12,4.15l1.07.16a52.79,52.79,0,0,0,9.3-5.76l-8.72-3.75L84,576.38c-.29,0-2.94.17-4.89.31Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M144.38,598.08c8.17,1.17-2.21,9.42-2.21,9.42s4,3,8.62,14,6.82,10.23,6.82,10.23l12.8.69c.4-5.62.74-9.71.74-9.71l-8.72-21.25-10.26-13.42s-17.1,4.75-22.93,8l-.17.1c-1,.55-1.58,1.06-1.72,1.5C127.09,598.45,144,594.09,144.38,598.08Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M193.48,439.13l-21.64-4.61A52.28,52.28,0,0,0,178.1,418l6.77,6.52a16.72,16.72,0,0,0,9.27-2.71,13.93,13.93,0,0,0,3.15-2.9c4.82-6,10.62-13.83,10.62-13.83s.67-.31,1.61-.65c2.54,2.19,5,3.66,7,3.66C224.55,408.06,193.48,439.13,193.48,439.13Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M77,576.83s9.42,22.25,18,22.65,47.1,6.21,47.1,6.21,4,3,8.62,14,6.82,10.22,6.82,10.22l14.83.81,2.8-16.84s1.61-6.22,11.43-23.85,10.82-36.88,10.82-36.88,3-5.81,2.21-8.42-3.41-23.25-3.61-25.46,4.41-12,4.41-12,8.82-12,8.61-13.83,3.41-7,3.41-7l8-13.19a6,6,0,0,0,.83,6.17c2.41,3.2.4,9.62.4,9.62l.49,8.09.11,1.93s-1.2,1.21-4.48,4.21-1.73,3.41-1.73,3.41c10.22-1.41,18.24,15.23,18.24,15.23s8.62-6,13-11.22a7.25,7.25,0,0,0,1.11-1.94c2.65-6.67-.06-20.91-.06-20.91,3.46-6.21-.85-11.83-.85-11.83,2.81-7.61-2.2-15.63-2.2-15.63L245,442.94c2.21-4.61-5.41-16-5.41-16s-1.8-8.62-3.41-9.42-3.4-4.41-3.4-4.41c.2-4-10.43-4.42-11.43-4.61a21.08,21.08,0,0,1-3.62-2.12,29,29,0,0,0-3.19-1.89c-1.81-.8-6.62,1.4-6.62,1.4s-5.81,7.82-10.62,13.83a14.45,14.45,0,0,1-3.15,2.91,16.78,16.78,0,0,1-9.28,2.7L178,418.65l-20.36,1.24-4.81,23.45c-10.43,8.62-6.42,18.44-6.62,24.85s-1.2,14-1.2,14-4.41,7.21-3.81,11-3.21,10-3.21,10-5.61,6.21-5,10.22-1,9.22-1,9.22-3.81,7-2.21,11,.81,6.22.81,6.22-8.22,1.2-8.82,5.61-8,6-8,6-13.23,4.82-16.44,7S77,576.83,77,576.83Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#ff718d"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M245.39,478.82s-15,1.8-16.83,4,15,2.4,15,2.4Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M223.15,490.74s11-3.9,11.32-2.7-11.32,7.81-11.32,7.81Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M218.54,469.4c-1.91,3-17.74,22.43-17.74,22.43l17-24.84Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M216.23,464.09c-1.2,1.6-13.93,22.44-13.93,22.44l12.83-23.45Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M242.89,439.13s-4.91-6.91-9.72-2.5S242.89,439.13,242.89,439.13Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M208.52,433.22s-12.53,0-18.65,2.81S195.29,427.61,208.52,433.22Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M194.14,423.8H196s4.31-1.61,5.41-4.93,9.76-.28,9.76-.28,1.26.94.16-.61,3.81-6.41,6-9.62a2.41,2.41,0,0,0,.39-.81,30.73,30.73,0,0,0-3.19-1.89c-1.81-.8-6.62,1.4-6.62,1.4s-5.81,7.82-10.62,13.83A14.45,14.45,0,0,1,194.14,423.8Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M194.14,422.6H196s4.31-1.61,5.41-4.93,9.76-.29,9.76-.29,1.26.95.16-.6,3.81-6.41,6-9.62a2.41,2.41,0,0,0,.39-.81,29,29,0,0,0-3.19-1.89c-1.81-.8-6.62,1.4-6.62,1.4s-5.81,7.82-10.62,13.83A14.45,14.45,0,0,1,194.14,422.6Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#ff718d"
});

var _ref113 = /*#__PURE__*/React.createElement("circle", {
  cx: 163.2,
  cy: 344.35,
  r: 1.33,
  fill: "#e7c7ca"
});

var _ref114 = /*#__PURE__*/React.createElement("circle", {
  cx: 140.33,
  cy: 375.45,
  r: 1.33,
  fill: "#e7c7ca"
});

var _ref115 = /*#__PURE__*/React.createElement("circle", {
  cx: 148.59,
  cy: 355.82,
  r: 1.33,
  fill: "#e7c7ca"
});

var _ref116 = /*#__PURE__*/React.createElement("circle", {
  cx: 136.64,
  cy: 395.68,
  r: 1.33,
  fill: "#e7c7ca"
});

var _ref117 = /*#__PURE__*/React.createElement("circle", {
  cx: 119.71,
  cy: 430.55,
  r: 1.33,
  fill: "#e7c7ca"
});

var _ref118 = /*#__PURE__*/React.createElement("circle", {
  cx: 118.38,
  cy: 448.42,
  r: 1.33,
  fill: "#e7c7ca"
});

var _ref119 = /*#__PURE__*/React.createElement("path", {
  d: "M115.11,409.67l2.71,8.72,8.52-.6,7.61-8.12s.5-1.46,1.28-3.64c1.92-5.37,5.55-15.12,7.54-18.11,2.81-4.21,4.62-21.65,4.62-21.65s-3.08-7-11.87,7C128.91,383.85,120.68,399.13,117,406,115.82,408.3,115.11,409.67,115.11,409.67Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#ecb4b6"
});

var _ref120 = /*#__PURE__*/React.createElement("path", {
  d: "M152.8,531.73c0,2.15,9,3.15,13.24,3.5,1.33.11,2.19.16,2.19.16-1,2.25,4.31,19.49,4.31,19.49a7.56,7.56,0,0,0,1.34-.17c7-1.41,20.8-11.05,20.8-11.05s.3-3.31,14.58-9.12c10.52-4.28,18.39-12.3,22.05-16.28a22.56,22.56,0,0,1,2.26-2.36l-12.63-13.13s-2.05,1.9-4.75,4.45c-4.94,4.66-12.07,11.5-12.79,12.81-1.1,2-20.94,11.7-20.94,11.7-4.41-3.8-13.93-4.61-13.93-4.61S152.8,528.92,152.8,531.73Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#ecb4b6"
});

var _ref121 = /*#__PURE__*/React.createElement("path", {
  d: "M176.35,486.53c-.61,1.21-27.76,19.25-32.37,19.55s4.31-8.62,4.61-8.72S176.35,486.53,176.35,486.53Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref122 = /*#__PURE__*/React.createElement("path", {
  d: "M29.83,772.94l-1-.23Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref123 = /*#__PURE__*/React.createElement("path", {
  d: "M109.09,791.15a11.13,11.13,0,0,1,4.22-1.44,30,30,0,0,0,8.42-.26,20.35,20.35,0,0,0-.61,7.41l-2.55-.1S109.05,794.7,109.09,791.15Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#fff",
  opacity: 0.3
});

var _ref124 = /*#__PURE__*/React.createElement("path", {
  d: "M30.49,773.07,30,773l.54.1Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref125 = /*#__PURE__*/React.createElement("path", {
  d: "M16.18,767.36l0,0Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref126 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2,767.37h0Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref127 = /*#__PURE__*/React.createElement("path", {
  d: "M30,773l-.12,0Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref128 = /*#__PURE__*/React.createElement("path", {
  d: "M167.36,727.19c.11,1.16.16,2.31.2,3.32a5.38,5.38,0,0,0,1.36,3.46l.06.07a48.41,48.41,0,0,0,.44-7.14C169.21,727.21,168.3,727.25,167.36,727.19Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#fff",
  opacity: 0.3
});

var _ref129 = /*#__PURE__*/React.createElement("path", {
  d: "M216.19,507.22c6.53-.42,12.09,6.36,15.12,11a22.56,22.56,0,0,1,2.26-2.36l-12.63-13.13S218.89,504.67,216.19,507.22Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref130 = /*#__PURE__*/React.createElement("path", {
  d: "M216.13,505.47c10.22-1.4,18.24,15.24,18.24,15.24s8.62-6,13-11.23a7.18,7.18,0,0,0,1.11-1.93c-2.39-5.72-8.95-15.26-26.28-11.63l.11,1.94s-1.2,1.2-4.48,4.21S216.13,505.47,216.13,505.47Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref131 = /*#__PURE__*/React.createElement("path", {
  d: "M216.13,506.68c10.22-1.41,18.24,15.23,18.24,15.23s8.62-6,13-11.22a7.25,7.25,0,0,0,1.11-1.94c-2.39-5.72-8.95-15.25-26.28-11.62l.11,1.93s-1.2,1.21-4.48,4.21S216.13,506.68,216.13,506.68Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#ff718d"
});

var _ref132 = /*#__PURE__*/React.createElement("path", {
  d: "M216.13,506.68c10.22-1.41,18.24,15.23,18.24,15.23s8.62-6,13-11.22a7.25,7.25,0,0,0,1.11-1.94c-2.39-5.72-8.95-15.25-26.28-11.62l.11,1.93s-1.2,1.21-4.48,4.21S216.13,506.68,216.13,506.68Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#fff",
  opacity: 0.1
});

var _ref133 = /*#__PURE__*/React.createElement("path", {
  d: "M115.11,409.67l2.71,8.72,8.52-.6,7.61-8.12s.5-1.46,1.28-3.64c-1.08.61-8.45,4.69-12.91,4.92-3.54.17-4.85-3.15-5.29-4.91C115.82,408.3,115.11,409.67,115.11,409.67Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref134 = /*#__PURE__*/React.createElement("path", {
  d: "M112.46,412.72c.19-.22.37-.44.56-.65,2-2.31,3.8-4.1,3.8-4.1a9.38,9.38,0,0,0,1.73,4.31,4.42,4.42,0,0,0,3.77,1.68,24.43,24.43,0,0,0,7.48-2.21c3.06-1.34,5.56-2.78,5.56-2.78l0,2.41.05,2.4v5.51s2.1,14.63-17.34,6.81c0,0,1.21-5.37-6.18-4.35Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref135 = /*#__PURE__*/React.createElement("path", {
  d: "M135.36,407.16l.1,4.81v5.52s2.1,14.63-17.34,6.81c0,0,1.4-6.21-8-4s6.72-14.13,6.72-14.13.68,6.23,5.5,6S135.36,407.16,135.36,407.16Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#ff718d"
});

var _ref136 = /*#__PURE__*/React.createElement("path", {
  d: "M135.36,407.16l.1,4.81v5.52s2.1,14.63-17.34,6.81c0,0,1.4-6.21-8-4s6.72-14.13,6.72-14.13.68,6.23,5.5,6S135.36,407.16,135.36,407.16Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#fff",
  opacity: 0.1
});

var _ref137 = /*#__PURE__*/React.createElement("path", {
  d: "M172.44,560.29c-.2-.3-1-24.25-4.11-24.85s-10.82,2.61-10.82,2.61l1.4,19.14Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref138 = /*#__PURE__*/React.createElement("path", {
  d: "M168.23,535.39c-1,2.25,4.31,19.49,4.31,19.49a7.56,7.56,0,0,0,1.34-.17c-.49-7.13-1.53-19.44-3.75-19.87a10.7,10.7,0,0,0-4.09.39C167.37,535.34,168.23,535.39,168.23,535.39Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var _ref139 = /*#__PURE__*/React.createElement("path", {
  d: "M173.64,559.69c-.2-.3-1-24.25-4.11-24.85s-10.82,2.6-10.82,2.6l1.4,19.15Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#ff718d"
});

var _ref140 = /*#__PURE__*/React.createElement("path", {
  d: "M173.64,559.69c-.2-.3-1-24.25-4.11-24.85s-10.82,2.6-10.82,2.6l1.4,19.15Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#fff",
  opacity: 0.1
});

var _ref141 = /*#__PURE__*/React.createElement("path", {
  d: "M145.89,417.42c2.41-3.77,3.85-8.06,5.25-12.3.67-2.05,1.34-4.13,1.8-6.23a24.82,24.82,0,0,0,17,10.56,49.5,49.5,0,0,1,2,4.77,13.42,13.42,0,0,1-2.07,12.44c-2.8,3.37-7.92,4.81-11.84,2.85a26.07,26.07,0,0,0-3.53-1.89c-2.66-.84-5.44.55-8.19,1a12.86,12.86,0,0,1-10.7-3.09C140,424.42,143.47,421.18,145.89,417.42Z",
  transform: "translate(-16.15 -90.8)",
  fill: "#985c7e"
});

var _ref142 = /*#__PURE__*/React.createElement("circle", {
  cx: 157.49,
  cy: 295.63,
  r: 24.85,
  opacity: 0.1
});

var _ref143 = /*#__PURE__*/React.createElement("circle", {
  cx: 157.49,
  cy: 294.01,
  r: 24.85,
  fill: "#ecb4b6"
});

var _ref144 = /*#__PURE__*/React.createElement("path", {
  d: "M155.25,377.06c-2.92-2-7.22-.41-10.3-2.18a7.69,7.69,0,0,1-3.12-4.08c-2.69-7.1,1.54-16,8.75-18.42,1.88-.62,3.88-.85,5.77-1.43,5.18-1.57,9.16-5.59,13.64-8.62a39.65,39.65,0,0,1,15.38-6.17c4.08-.7,8.6-.65,11.92,1.81,3.76,2.77,5,7.78,5.73,12.39s1.54,9.59,4.86,12.87c2.65,2.63,6.43,3.66,9.8,5.23s6.78,4.29,7,8c.17,2.92-1.66,5.55-2.23,8.42-.64,3.22.35,6.53,1.47,9.63A114.93,114.93,0,0,0,236.3,419.1a67.27,67.27,0,0,1-19.69,7.26c-2.83.56-5.82.93-8.57.05-3.49-1.12-6.09-4.11-7.76-7.37a24.25,24.25,0,0,1-2.62-9.28c-.49-6.45,1.53-13.36-1.33-19.17a6.62,6.62,0,0,0-2.44-2.89c-1.26-.74-2.79-.82-4.18-1.26-2.4-.76-4.33-2.53-6.18-4.24L176.92,376a18.41,18.41,0,0,0-5.15-3.78c-3.52-1.5-7.67-.65-11,1.22-2.93,1.64-6.31,4.11-9.28,2.52",
  transform: "translate(-16.15 -90.8)",
  fill: "#985c7e"
});

var _ref145 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M153.25,376.49l-1.77-.5A4.3,4.3,0,0,0,153.25,376.49Z",
  transform: "translate(-16.15 -90.8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.25,376.49l2,.57a5.3,5.3,0,0,0-1.13-.59A5.06,5.06,0,0,1,153.25,376.49Z",
  transform: "translate(-16.15 -90.8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M217.42,423.11c-2.83.56-5.82.93-8.57.05-3.48-1.12-6.08-4.11-7.76-7.36a24.53,24.53,0,0,1-2.62-9.28c-.49-6.45,1.53-13.37-1.33-19.17a6.62,6.62,0,0,0-2.44-2.89c-1.26-.75-2.79-.83-4.18-1.27-2.4-.75-4.33-2.52-6.17-4.24l-6.62-6.17a18.61,18.61,0,0,0-5.15-3.78c-3.52-1.49-7.67-.64-11,1.22-2.09,1.17-4.41,2.76-6.64,3a5.07,5.07,0,0,1,1.13.59l-2-.57a4.2,4.2,0,0,1-1.76-.49l1.76.49a5.06,5.06,0,0,0,.87,0c-2.82-1.09-6.47,0-9.17-1.59a7.69,7.69,0,0,1-3.12-4.08,13.17,13.17,0,0,1-.67-6.49,13.85,13.85,0,0,0-.14,9.74,7.69,7.69,0,0,0,3.12,4.08c2.7,1.55,6.34.5,9.17,1.59,2.23-.25,4.55-1.83,6.64-3,3.34-1.87,7.49-2.72,11-1.22a18.22,18.22,0,0,1,5.14,3.78l6.62,6.17c1.85,1.71,3.78,3.48,6.18,4.24,1.39.44,2.92.52,4.18,1.26a6.62,6.62,0,0,1,2.44,2.89c2.86,5.81.84,12.72,1.33,19.17a24.25,24.25,0,0,0,2.62,9.28c1.67,3.26,4.27,6.25,7.76,7.37,2.75.88,5.74.51,8.57-.05a67.11,67.11,0,0,0,19.68-7.26c-.45-.69-.9-1.39-1.34-2.1A66.85,66.85,0,0,1,217.42,423.11Z",
  transform: "translate(-16.15 -90.8)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M224.66,377.42a28.58,28.58,0,0,0-1.4,4.22c-.06.32-.1.63-.13.95A20.11,20.11,0,0,0,224.66,377.42Z",
  transform: "translate(-16.15 -90.8)"
}));

var _ref146 = /*#__PURE__*/React.createElement("path", {
  d: "M170,424.74c-2.8,3.37-7.92,4.81-11.84,2.85a24.94,24.94,0,0,0-3.53-1.88c-2.66-.85-5.44.55-8.19,1a12.86,12.86,0,0,1-9.21-2,12.37,12.37,0,0,1-1.49.49,12.84,12.84,0,0,0,10.7,3.1c2.75-.49,5.53-1.88,8.19-1a24.94,24.94,0,0,1,3.53,1.88c3.92,2,9,.53,11.84-2.85a12.7,12.7,0,0,0,2.71-8.86A12.41,12.41,0,0,1,170,424.74Z",
  transform: "translate(-16.15 -90.8)",
  opacity: 0.1
});

var SvgAnalytics = function SvgAnalytics(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b86c1a25-be3a-4728-a0a8-9021f461e354",
    "data-name": "Layer 1",
    width: 1167.7,
    height: 718.39,
    viewBox: "0 0 1167.7 718.39",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125, _ref126, _ref127, _ref128, _ref129, _ref130, _ref131, _ref132, _ref133, _ref134, _ref135, _ref136, _ref137, _ref138, _ref139, _ref140, _ref141, _ref142, _ref143, _ref144, _ref145, _ref146);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnalytics, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analytics.56b69e10.svg";
export { ForwardRef as ReactComponent };